import { memo } from 'react';
import { Box, DialogTitle as MuiDialogTitle, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import { DialogTitleProps } from '../types';

// DialogTitle: A customizable component for dialog titles with optional draggability
export const DialogTitle = memo(({ title, onClose, icon }: DialogTitleProps) => {
  const theme = useTheme();
  return (
    <MuiDialogTitle
      // Add draggable class if applicable
      sx={{
        textAlign: 'left',
        padding: theme.spacing(1.5, 2),
        backgroundColor: theme.palette.action.hover,
        fontSize: theme.typography.h6.fontSize,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Title content with optional drag indicator */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {icon && <Box sx={{ mr: 1 }}>{icon}</Box>}
          {title}
        </Box>
        {/* Close button */}
        <IconButton
          aria-label="close"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </MuiDialogTitle>
  );
});
DialogTitle.displayName = 'DialogTitle';
